/* eslint-disable formatjs/no-literal-string-in-jsx */
import React from 'react';
import { Box, InlineMessage, Typography } from '@saviynt/design-system';
import cx from 'classnames';

import { CF_CRT_MED, CF_NEU_BLD } from '../../constants';

import FormInputElement from './FormInputElement';
import { type TrackedFormData, type TrackedFormFieldState } from './types';

interface FormFieldProp {
  field: TrackedFormFieldState;
  setFormData: React.Dispatch<React.SetStateAction<TrackedFormData[]>>;
  level: number;
  isNoSection: boolean;
}

/**
 * FormField
 * @param field
 * @param setFormData
 * @param level
 * @param isNoSection
 */
function FormField({ field, setFormData, level, isNoSection }: FormFieldProp) {
  const {
    name,
    label,
    type,
    value,
    placeholder,
    isEditable,
    isRequired,
    isMultiple,
    formats,
    options,
    endpoint,
    totalFileSize,
    fileCount,
    fileSize,
    tracker: { isCritical },
  } = field;

  return (
    <Box
      className={cx(
        'FormField',
        level === 0 && isNoSection && 'FormField--isVerticalLayout'
      )}>
      <Box tag='div' className='FormField-label'>
        {isRequired && (
          <Typography
            kind='h3'
            color={CF_CRT_MED}
            className='FormField-requiredIndicator'>
            *
          </Typography>
        )}
        <Typography kind='h4' color={CF_NEU_BLD}>
          {label}
        </Typography>
      </Box>
      <Box tag='div' className='FormField-body'>
        <Box tag='div' className='FormField-bodyInput'>
          <FormInputElement
            name={name}
            type={type}
            value={value}
            initialOptions={options}
            placeholder={placeholder}
            isEditable={isEditable}
            setFormData={setFormData}
            endpoint={endpoint}
            isCritical={isCritical}
            isMultiple={isMultiple}
            totalFileSize={totalFileSize}
            fileCount={fileCount}
            fileSize={fileSize}
            formats={formats}
          />
        </Box>
        {isCritical && (
          <InlineMessage kind='missingRequiredField' size='small' />
        )}
      </Box>
    </Box>
  );
}

export default FormField;
